import BlockTitle from "./BlockTitle";

export default BlockTitle;
